// extracted by mini-css-extract-plugin
export default {"wrapper":"Files_wrapper__3Fcr4","id":"Files_id__y9gRh"};